import { useEffect, useState } from 'react';

import { hasAmsSessionArtifact } from 'service/amsSession';
import { LegacyApp } from 'components/App/LegacyApp';
import { AmsGate } from 'components/AmsAuth/AmsGate';
import { AuthedAppServices } from 'components/AmsAuth/AuthedAppServices';

/**
 * Auth mode dispatcher. The artifact decides: an amsAuth refresh cookie means
 * this browser holds an AMS session (adopted at login when the company's
 * ams_spa_auth_enabled flag was on), anything else is the legacy Cognito
 * cookie flow. Resolved after mount because the static-export prerender has no
 * cookies — both branches render null on their first client frame anyway.
 */
export const App = ({ children }) => {
  const [amsMode, setAmsMode] = useState(null);

  useEffect(() => {
    setAmsMode(hasAmsSessionArtifact());
  }, []);

  if (amsMode === null) {
    return null;
  }

  if (amsMode) {
    return (
      <AmsGate>
        <AuthedAppServices>{children}</AuthedAppServices>
      </AmsGate>
    );
  }

  return <LegacyApp>{children}</LegacyApp>;
};
